<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import debug from '@/helpers/debug'
import { sortRecurringSeriesForList } from '@/helpers/recurring/seriesList'
import { useRecurringDonationModal } from '@/composables/useRecurringDonationModal'
import RecurringSeriesRow from '@/components/dashboard/giving/RecurringSeriesRow.vue'
import type { RecurringDonationSeries } from '@/types/recurringDonation'

const props = defineProps<{
  series: RecurringDonationSeries[]
}>()

const { t } = useI18n()
const { openRecurringDonationModal } = useRecurringDonationModal()

const sorted = computed(() => sortRecurringSeriesForList(props.series))

const openSeries = (series: RecurringDonationSeries) => {
  debug('Opening a recurring donation from the schedules list', {
    seriesId: series.id,
    status: series.status,
  })
  openRecurringDonationModal(series.id)
}
</script>

<template>
  <!--
    Every schedule is listed here, including one whose first date is still in
    the future or whose generated donations were all deleted.
  -->
  <section
    v-if="sorted.length"
    class="sa-recurring-series"
    aria-labelledby="recurring-series-heading"
  >
    <h2 id="recurring-series-heading" class="visually-hidden">
      {{ t('Dashboard.Giving.RecurringList.Heading') }}
    </h2>
    <ul class="sa-donation-list sa-recurring-series__list">
      <li v-for="item in sorted" :key="item.id">
        <RecurringSeriesRow :series="item" @open="openSeries(item)" />
      </li>
    </ul>
  </section>
</template>
